import {createQueryKeys} from '@lukemorales/query-key-factory'
import {api} from 'api'

export const showTypes = createQueryKeys('showTypes', {
  list: {
    queryKey: null,
    queryFn: () => api.showTypes.list(),
  },
})
